import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import styled from '@emotion/styled';
import theme from '../../theme';


export const FormTitleText = styled(Typography)({
  color: theme.palette.primary.w900,
})

export const SpanError = styled('span')(({ theme }) => ({
  marginLeft: '6px',
  color: theme.palette.error.main
}))

export const TextFieldCleanStyle = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: '8px',
    backgroundColor: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}))

export const TextFieldWhite = styled(OutlinedInput)(({ theme }) => ({
  minWidth: '300px',
  paddingLeft: '6px',
  paddingRight: '6px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  boxShadow: `0px 2px 4px ${theme.palette.grey.w200}`,

  '& .MuiInputBase-input': {
    height: '36px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    transition: 'border .5s',
    border: '1px solid white',
    borderRadius: '8px',
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w400,
      borderWidth: '1px',
    }
  },
  '&.Mui-disabled': {
    backgroundColor: '#E6ECF2',
    boxShadow: 'none',

    '& .MuiInputBase-input': {
      WebkitTextFillColor: theme.palette.grey.w700,
      backgroundColor: '#E6ECF2',
      boxShadow: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w400,
      borderWidth: '1px',
    }
  },
  '& .MuiInputBase-inputMultiline': {

  },
}))

export const TextFieldLarge = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    height: '40px',
    padding: '6px 10px',
    borderRadius: '16px',
    backgroundColor: '#fff'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.w600,
    transition: 'border .5s',
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w400,
      borderWidth: '2px',
    }
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.w600,
      borderWidth: '2px',
    }
  },
}))